/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TenantAndConfigs } from '../../models/tenant-and-configs';

export interface GetTenantByShortCode$Params {

/**
 * shortCode of the tenant (based on the subdomain)
 */
  short_code: string;
}

export function getTenantByShortCode(http: HttpClient, rootUrl: string, params: GetTenantByShortCode$Params, context?: HttpContext): Observable<StrictHttpResponse<TenantAndConfigs>> {
  const rb = new RequestBuilder(rootUrl, getTenantByShortCode.PATH, 'get');
  if (params) {
    rb.path('short_code', params.short_code, {"style":"simple","explode":false});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TenantAndConfigs>;
    })
  );
}

getTenantByShortCode.PATH = '/api/v1/tenants/config/{short_code}';
